/*
 * @Descripttion: 
 * @version: 
 * @Author: sueRimn
 * @Date: 2019-12-30 16:10:48
 * @LastEditors: sueRimn
 * @LastEditTime: 2020-01-02 19:31:56
 */

export default {
    TRANS_TOOL:'WX_TRANS_TOOL', // 陪诊翻译 /im/accompanyTrans

    TOAST_BUILDING:'WX_TOAST_BUILDING', // toast提示 功能建设中

    ONLINE_INQUIRY:'WX_ONLINE_INQUIRY', // 在线问诊saas /hospital/list?hospNext=HOSPITAL_DEPARTMENT&fn=WX_ONLINE_INQUIRY
    APPOINTMENT:'WX_APPOINTMENT', // 预约挂号saas /appointment/branch?selectHosp=1&fn=WX_APPOINTMENT
    NETCLINIC:'WX_NETCLINIC', // 网络门诊 /hospital/list?hospNext=HOSPITAL_DEPARTMENT&fn=WX_NETCLINIC

    INQUIRY_TEXT:'WX_INQUIRY_TEXT', //图文问诊saas /hospital/list?hospNext=HOSPITAL_DEPARTMENT&inquiryType=10
    INQUIRY_VIDEO:'WX_INQUIRY_VIDEO', //视频问诊saas /hospital/list?hospNext=HOSPITAL_DEPARTMENT&inquiryType=30
    INQUIRY_PHONE:'WX_INQUIRY_PHONE', // 电话问诊saas /hospital/list?hospNext=HOSPITAL_DEPARTMENT&inquiryType=20
    INTER: 'WX_INQUIRY_HOME', // 在线问诊首页 /interrogation

    SPEED_INQUIRY:'WX_SPEED_INQUIRY', // 极速咨询 不使用落地页


    OUTPATIENT_RECIPEL:'WX_OUTPATIENT_RECIPEL', // 门诊处方(线下处方,新元素) /order/outpatientRecipel
    MEDICAL_RECORD:'WX_MEDICAL_RECORD', // 病历 /outpatient/medicalRecord
    MEDICAL_RECORD_LIST:'WX_MEDICAL_RECORD_LIST', // 病历记录 /outpatient/medicalRecordList
    

    CARD_PACKAGE:'WX_CARD_PACKAGE', // 卡包 /patient/medicalCard
    MY_COLLECTION:'WX_MY_COLLECTION', // 我的收藏 /userCenter/myCollection

    OUTPATIENT_NO: 'WX_OUTPATIENT_NO',//在线取号
    TRIAGE_NO: 'WX_TRIAGE_NO',//分诊叫号
    OUTPATIENT_PAY: 'WX_OUTPATIENT_PAY',//门诊缴费 /outpatient/outpatientPayList
    REPORT: 'WX_REPORT',//报告查询  /reportQuery/reportList
    INPATIENT: 'WX_INPATIENT',//住院服务  /inpatient
    APPT_PE: 'WX_APPT_PE',//检查预约
    APPT_PACS: 'WX_APPT_PACS',//体检预约
    CARD_CHARGE: 'WX_CARD_CHARGE',//就诊卡充值  /patient/cardCharge
    OUTPATIENT_ONLINE: 'WX_OUTPATIENT_ONLINE',//网络门诊
    REPORT_ANALYSIS: 'WX_REPORT_ANALYSIS',//报告解读
    ANTENATAL: 'WX_ANTENATAL',//孕产服务  /antenatal
    HOME_DOCTOR: 'WX_HOME_DOCTOR',//家庭医生
    HEALTH: 'WX_HEALTH',//健康管理
    HOME_DOCTOR_VISIT: 'WX_HOME_DOCTOR_VISIT',//家医随访
    MSITE: 'WX_MSITE',//微官网  /msite
    INTRODUCE_DOC: 'WX_INTRODUCE_DOC',//医生介绍   /doctor/doctorListMsite
    INTRODUCE_DEPT: 'WX_INTRODUCE_DEPT',//科室介绍  /appointment/branch
    HOSPITAL_INDEX: 'WX_HOSPITAL_INDEX',//医院主页  /hospital/introduce
    USERCENTER: 'WX_USERCENTER',//个人中心  /userCenter
    HOME: 'WX_HOME',//微信首页  /home 

    AI_MEDICAL_ASSISTANT: 'WX_AI_MEDICAL_ASSISTANT',//AI就医助手  /ext/assist
    ELECTRONIC_HEALTH_CODE: 'WX_ELECTRONIC_HEALTH_CODE', //电子健康码 /patient/patientList
    MEMBER_LIST: 'WX_MEMBER_LIST',//家庭成员管理  /patient/patientList
    MY_FOCUS_DOCTOR: 'WX_MY_FOCUS_DOCTOR',//我的关注 /userCenter/myDoctor
    MESSAGE_VISIT: 'WX_MESSAGE_VISIT',//就诊消息
    MESSAGE_SYS: 'WX_MESSAGE_SYS',//系统消息
    SUBSEQUENT_VISIT: 'WX_SUBSEQUENT_VISIT',//网络门诊
    OTHERS: 'WX_OTHERS',//其他消息
    PERSONAL_DISEASE_PREDICTION: 'WX_PERSONAL_DISEASE_PREDICTION',//个人疾病预测 /personalDisease
    HOME_DEPT_DOCTOR: 'WX_HOME_DEPT_DOCTOR',//按科室找医生
    DOCTOR_MANAGE: 'WX_DOCTOR_MANAGE',//家医管理  /ext/doctorManage
    HEALTH_EDUCATION: 'WX_HEALTH_EDUCATION',//健康教育 /ext/healtheDucation
    OUTPATIENT_PAY_HISTORY: 'WX_OUTPATIENT_PAY_HISTORY',//缴费记录  /outpatient/outpatientPayList?active=1
    USERCENTER_SETTINGS: 'WX_USERCENTER_SETTINGS',//个人中心设置 /userCenter/account
    HOME_SEARCH: 'WX_HOME_SEARCH',//首页搜索 /hospital/search
    MESSAGE_CENTER: 'WX_MESSAGE_CENTER',//消息中心 /userCenter/messageList
    FEEDBACK: 'WX_FEEDBACK',//意见反馈  /userCenter/feedBack
    ADDRESSLIST: 'WX_ADDRESSLIST',//地址管理  /userCenter/addressList
    PROBLEMLIST: 'WX_PROBLEMLIST',//问题列表  /userCenter/problemList

    BIDIRECTIONAL_REFERRAL: 'BIDIRECTIONAL_REFERRAL',// 双向转诊 外链
    HEALTH_ARCHIVES: 'HEALTH_ARCHIVES',// 健康档案 外链
    MALL_HOME: 'WX_MALL_HOME',// 商城首页 /mall/home
    MEDICAL_CARD: 'WX_MEDICAL_CARD',// 就医码 /patient/medicalCard
    BUILDING: 'WX_BUILDING',// 建设中 /building
    BUILDING1: 'WX_BUILDING1',// 建设中 /building

    // 订单相关
    ORDER_APPT: 'WX_ORDER_APPT',//挂号订单 /order/apptOrderList
    ORDER_ANTENATAL: 'WX_ORDER_ANTENATAL',//孕产订单 /order/antenatalOrderList
    ORDER_INPATIENT: 'WX_ORDER_INPATIENT',//住院订单 /order/inpatientOrderList
    ORDER_RECIPEL: 'WX_ORDER_RECIPEL',//处方订单 /order/recipelOrderList
    ORDER_INTER: 'WX_ORDER_INTER',//问诊订单 /im/inquiryOrderList
    CARD_CHARGE_RECORD: 'WX_CARD_CHARGE_RECORD',//充值记录 /patient/cardChargeRecord

    
    SEARCH_HOSPITAL:'WX_SEARCH_HOSPITAL',// 找医院  /hospital/list?hospNext=HOSPITAL_INDEX
    SEARCH_DOCTOR:'WX_SEARCH_DOCTOR', // 找医生 /doctor/search
    INQUIRY_RULES:'WX_INQUIRY_RULES', // 问诊须知 /interrogation/rules
    DEPARTMENT_ALL:'WX_DEPARTMENT_ALL',// 全部科室 /hospital/departmentAll
    
    RECOMMEND_DOCTOR:'WX_RECOMMEND_DOCTOR',//推荐医生 /doctor/recommend_all
    INTER_RECENT:'WX_INTER_RECENT', //最近问诊 /im/recentInter
    USERAGREEMENT:'WX_USERAGREEMENT',//用户协议 /userCenter/userAgreement
    USERPRIVACYAGREEMENT:'WX_USERPRIVACYAGREEMENT',//隐私协议 /userCenter/userPrivacyAgreement
    MY_RECIPEL:'WX_MY_RECIPEL',//我的处方 /order/myRecipelOrderList
    
    INQUIRY_GUIDANCE:'WX_INQUIRY_GUIDANCE',//导诊咨询  /interrogation/inquiryGuidance
    TEXT_PICTURE_INQUIRY:'WX_TEXT_PICTURE_INQUIRY', //图文问诊 /hospital/list?hospNext=HOSPITAL_DEPARTMENT&inquiryType=10
    FIRST_VISIT:'WX_FIRST_VISIT', //初诊咨询（在线咨询）-区域级 /hospital/list?hospNext=HOSPITAL_DEPARTMENT&inquiryType=60
    RETURN_VISIT:'WX_RETURN_VISIT',//网络门诊 /interrogation/returnVisit
    EASY_INQUIRY:'WX_EASY_INQUIRY',// 简易门诊 /interrogation/easyInquiry

    APPT_PRE: 'WX_APPT_PRE',//预约挂号  /appointment/branch?isToday=0&selectHosp=1  已废弃
    APPT_TODAY: 'WX_APPT_TODAY',//当天挂号  /appointment/branch?isToday=1&selectHosp=1 已废弃


}